import { useTranslations } from '@lang';
import { getMondayFirstWeekdays } from '@utils/date';
import { useMemo } from 'react';
import type { ExtrasTemplateLabels } from 'voyager';

export type RoomExtrasLabels = Omit<ExtrasTemplateLabels, 'footerTitle' | 'ctaLabel'>;

export const useRoomExtrasLabels = (language: string): RoomExtrasLabels => {
  const { t } = useTranslations();
  const weekdays = useMemo(() => getMondayFirstWeekdays(language), [language]);

  return useMemo(
    () => ({
      title: t('room.extrasStepTitle'),
      subtitle: t('room.extras.subtitle'),
      backAriaLabel: t('common.back'),
      add: t('room.extras.add'),
      remove: t('room.extras.remove'),
      quantity: t('room.extras.quantity'),
      editSelections: t('room.extras.editSelections'),
      noImage: t('room.extras.noImage'),
      loading: t('room.extras.loading'),
      footerTotal: t('basket.total'),
      modalTitle: t('room.extras.selectGuests'),
      modalConfirm: t('modalError.confirm'),
      modalClose: t('journeypicker.close'),
      modalTotal: t('basket.total'),
      dateModalTitle: t('room.extras.selectDate'),
      dateRangeModalTitle: t('room.extras.selectDateRange'),
      timeRangeModalTitle: t('room.extras.selectTimeRange'),
      dateTimeModalTitle: t('room.extras.selectDateTime'),
      dateTimeRangeModalTitle: t('room.extras.selectDateTimeRange'),
      quantityModalTitle: t('room.extras.selectQuantity'),
      applyToAll: t('room.extras.applyToAll'),
      perUnit: t('room.extras.perUnit'),
      perGuest: t('room.extras.perGuest'),
      timesLabel: t('room.extras.times'),
      previousWeek: t('room.extras.previousWeek'),
      nextWeek: t('room.extras.nextWeek'),
      progressLabel: t('aria.bookingProgress'),
      fromPrice: t('common.from'),
      weekdays,
    }),
    [t, weekdays]
  );
};
